import { validateGuests } from "../../validators";
import {
  BOOKING_GOTO_STEP,
  BOOKING_INFO_BOOKING_RESULT_SAVE,
  BOOKING_INFO_GUEST_INFO_CHANGE,
  BOOKING_INFO_GUEST_INFO_INIT,
  BOOKING_INFO_PAYMENT_CHECKOUT_RESET,
  BOOKING_INFO_PAYMENT_CHECKOUT_SAVE,
  BOOKING_INFO_PAYMENT_IDLE,
  BOOKING_INFO_PAYMENT_INTENT_RESET,
  BOOKING_INFO_PAYMENT_INTENT_SAVE,
  BOOKING_INFO_PAYMENT_LOADING,
  BOOKING_INFO_PAYMENT_RESULT_SAVE,
  BOOKING_INFO_REMARKS_CHANGE,
  BOOKING_INIT_STEP,
  BOOKING_PREV_STEP,
} from "./types";

import React from "react";

import {
  savePriceInfo,
  savePriceInfoSearchData,
  savePriceInfoSearchSessionInfo,
} from "../single_search/addon_search";
import { toast } from "react-toastify";
import { storeSearchSessionMetadata } from "../../api";
import { getGuestsFormInfoSelector } from "../../selectors/booking_process/guests";

export const cancelBooking = () => {
  return {
    type: BOOKING_GOTO_STEP,
    step: 0,
  };
};

export const gotoPrevStep = () => {
  return {
    type: BOOKING_PREV_STEP,
  };
};

export const gotoGuestInfo = (
  { initialize = true } = { initialize: true }
) => async (dispatch) => {
  if (initialize) {
    await dispatch(initGuestInformation());
  }
  await dispatch(resetPaymentIntent());
  await dispatch(resetPaymentCheckout());
  dispatch({ type: BOOKING_GOTO_STEP, step: 1 });
};

export const resetBookingInformation = () => {
  return { type: BOOKING_INIT_STEP };
};

export const initBooking = ({
  reference,
  date,
  adults,
  children,
  children_ages,
  booking_mode,
  history,
}) => async (dispatch, getState) => {
  await dispatch(savePriceInfo({ booking_mode }));
  await dispatch(
    savePriceInfoSearchData({
      adults,
      children,
      children_ages,
      date,
      reference,
    })
  );

  await dispatch(initGuestInformation(adults, children));
  await dispatch(gotoGuestInfo({ initialize: false }));

  const session_result = await storeSearchSessionMetadata({
    service_type: "MI",
    session_data: getState().TourPriceInfo,
  });
  if (!session_result) {
    toast.warning("", { duration: 5000 });
    return;
  }
  const { session_id: page_session_id } = session_result;
  dispatch(savePriceInfoSearchSessionInfo({ page_session_id }));

  history.push(`/tour/booking_process/${page_session_id}`);
};

export const initGuestInformation = (adults, children) => {
  return {
    type: BOOKING_INFO_GUEST_INFO_INIT,
    adults,
    children,
  };
};

export const changeGuestInfo = (uid, formValue, travellerType) => {
  return {
    type: BOOKING_INFO_GUEST_INFO_CHANGE,
    uid,
    formValue,
    travellerType,
  };
};

export const changeRemarks = (formValue) => {
  return {
    type: BOOKING_INFO_REMARKS_CHANGE,
    remarks: formValue.remarks,
    pickup: formValue.pickup,
    address: formValue.address,
  };
};

export const gotoBookingRemarks = () => {
  return { type: BOOKING_GOTO_STEP, step: 2 };
};

export const gotoFinalBookingStep = () => {
  return { type: BOOKING_GOTO_STEP, step: 3 };
};

export const gotoNativePayment = () => {
  return { type: BOOKING_GOTO_STEP, step: 4 };
};

export function gotoExternallyHostedPayment() {
  return { type: BOOKING_GOTO_STEP, step: 3 };
}

export function gotoBarclaysPayment() {
  return { type: BOOKING_GOTO_STEP, step: 3 };
}

const resetPaymentIntent = () => {
  return { type: BOOKING_INFO_PAYMENT_INTENT_RESET };
};

export const savePaymentIntent = (paymentIntent) => {
  return { type: BOOKING_INFO_PAYMENT_INTENT_SAVE, paymentIntent };
};

export const resetPaymentCheckout = () => {
  return { type: BOOKING_INFO_PAYMENT_CHECKOUT_RESET };
};

export const savePaymentCheckout = (paymentCheckout) => {
  return { type: BOOKING_INFO_PAYMENT_CHECKOUT_SAVE, paymentCheckout };
};

export const loadingPayment = () => {
  return { type: BOOKING_INFO_PAYMENT_LOADING };
};

export const idlePayment = () => {
  return { type: BOOKING_INFO_PAYMENT_IDLE };
};

export const savePaymentResult = (paymentResult) => {
  return { type: BOOKING_INFO_PAYMENT_RESULT_SAVE, paymentResult };
};

export const gotoPaymentFailed = () => {
  return { type: BOOKING_GOTO_STEP, step: 5 };
};

export const gotoBookingFail = () => {
  return { type: BOOKING_GOTO_STEP, step: 7 };
};

export const gotoBookingSuccess = () => {
  return { type: BOOKING_GOTO_STEP, step: 8 };
};

export const saveBookingResult = (bookingResult) => {
  return { type: BOOKING_INFO_BOOKING_RESULT_SAVE, bookingResult };
};

export * from "./hotel";
export * from "./addons";
